import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap, concatMap, withLatestFrom } from 'rxjs';
import * as DashboardActions from '../actions/dashboard.actions';
import { NavigationService } from '@core/services/navigation.service';
import { select, Store } from '@ngrx/store';
import * as fromDashboard from '@root-store/dashboard-store/index';
import { clone } from 'underscore';

@Injectable()
export class DashboardEffects {
  private readonly actions = inject(Actions);
  private readonly navigationService = inject(NavigationService);
  private readonly store = inject(Store<fromDashboard.State>);

  refresh$ = createEffect(() => {
    return this.actions.pipe(
      ofType(DashboardActions.Refresh),
      withLatestFrom(this.store.pipe(select(fromDashboard.selectors.getSelectedPeriod))),
      concatMap(([action, statPeriod]) => [DashboardActions.SelectPeriod({ period: clone(statPeriod) })]),
    );
  });

  selectEventSession$ = createEffect(
    () => {
      return this.actions.pipe(
        ofType(DashboardActions.SelectEventSession),
        tap((eventSelection) => {
          if (eventSelection.fromDashboard)
            this.navigationService.navigate(this.navigationService.getSalesUrl());
        }),
      );
    },
    { dispatch: false },
  );
}
